module.exports = __webpack_public_path__ + "static/media/rotaCoffee.1d44c7c0.svg";